import { stringToNumber } from 'annotation-tools/utils';
import { viewTexts } from '../../constants/view-texts';
import { ListWithPromiseState } from '../../global-state/database/common/list-with-status';
import { pathnameElements } from '../../routing/routes';
import { ICompanyType } from '../../types/record/company';
import {
  IImageInfoType,
  IProjectImageInfoType
} from '../../types/record/image-info';
import { IKoumutenType } from '../../types/record/koumuten';
import { IModelType } from '../../types/record/model';
import { IProjectType } from '../../types/record/project';
import { IUserType } from '../../types/record/user';
import { ICsvType } from '../../types/record/csv';

export const getPathDisplayNameList = (
  pathname: string[],
  userList: ListWithPromiseState<IUserType>,
  csvList: ListWithPromiseState<ICsvType>,
  koumutenList: ListWithPromiseState<IKoumutenType>,
  companyList: ListWithPromiseState<ICompanyType>,
  modelList: ListWithPromiseState<IModelType>,
  projectList: ListWithPromiseState<IProjectType>,
  modelImageList: ListWithPromiseState<IImageInfoType>,
  projectImageList: ListWithPromiseState<IProjectImageInfoType>
): string[] =>
  pathname
    .map((p, idx) => {
      const mapped = viewTexts.pathDisplayName.get(p);
      if (mapped !== undefined) return mapped; // pがpathDisplayNameのkeyに存在する場合

      const pathElAsNumber = stringToNumber(p);

      if (idx === 1) {
        if (pathname[0] === pathnameElements.users) {
          return userList.value.latest.find(e => e.id === pathElAsNumber)?.name;
        }
        if (pathname[0] === pathnameElements.koumutens) {
          return koumutenList.value.latest.find(e => e.id === pathElAsNumber)
            ?.name;
        }
        if (pathname[0] === pathnameElements.csvs) {
          return csvList.value.latest.find(e => e.id === pathElAsNumber)
            ?.name;
        }
      }
      if (idx === 3) {
        if (pathname[2] === pathnameElements.companies) {
          return companyList.value.latest.find(e => e.id === pathElAsNumber)
            ?.name;
        }
      }
      if (idx === 5) {
        if (pathname[4] === pathnameElements.models) {
          return modelList.value.latest.find(e => e.id === pathElAsNumber)
            ?.name;
        }
        if (pathname[4] === pathnameElements.projects) {
          return projectList.value.latest.find(e => e.id === pathElAsNumber)
            ?.name;
        }
      }
      if (idx === 7) {
        if (
          pathname[4] === pathnameElements.models &&
          pathname[6] === pathnameElements.images
        ) {
          return modelImageList.value.latest.find(e => e.id === pathElAsNumber)
            ?.name;
        }
        if (
          pathname[4] === pathnameElements.projects &&
          pathname[6] === pathnameElements.images
        ) {
          return projectImageList.value.latest.find(
            e => e.id === pathElAsNumber
          )?.name;
        }
      }

      return p;
    })
    .map(e => e ?? viewTexts.emptyPathElem);
